import { action, computed, makeObservable, observable } from 'mobx';
import { boolean } from 'zod';

export class GlobalLoaderStore {
   queue = 0;

   constructor() {
      makeObservable(this, {
         queue: observable,
         visible: computed,
         show: action.bound,
         hide: action.bound
      });
   }

   get visible(): boolean {
      return this.queue > 0;
   }

   show() {
      this.queue++;
   }

   hide() {
      if (this.queue > 0) {
         this.queue--;
      }
   }
}
